const medicineProductDe = {
	breadcrumbs: {
		home: 'Startseite',
		medicineBazar: 'Medizin Bazar'
	},
	loading: 'Laden...',
	labels: {
		prescriptionRequired: 'Rezept erforderlich',
		reviewsSuffix: 'Bewertungen',
		deliveryPrefix: 'Lieferung:',
		minOrderPrefix: 'Mindestbestellung:',
		perUnitPrefix: 'Pro',
		expiry: 'Ablauf:',
		stock: 'Bestand:',
		inStock: 'Auf Lager',
		outOfStock: 'Nicht verfügbar',
		availableUnitsSuffix: 'verfügbar',
		selectQuantity: 'Menge wählen:',
		unitLabel: 'Einheit',
		unitStrip: 'Streifen',
		unitBox: 'Schachtel',
		unitTablet: 'Tablette',
		unitBottle: 'Flasche',
		unitVial: 'Durchstechflasche',
		unitAmpule: 'Ampulle',
		unitTube: 'Tube',
		unitSachet: 'Beutel',
		unitInhaler: 'Inhalator',
		perUnitNotePrefix: '* Pro',
		totalAmountPrefix: 'Gesamt:',
		addToCart: 'In den Warenkorb',
		wishlistAria: 'Zur Wunschliste hinzufügen',
		shareAria: 'Teilen',
		descriptionTab: 'Beschreibung',
		specsTab: 'Spezifikationen',
		reviewsTab: 'Bewertungen',
		productDescriptionTitle: 'Beschreibung des Medikaments',
		productSpecsTitle: 'Spezifikationen des Medikaments',
		customerReviewsTitle: 'Kundenbewertungen',
		relatedTitle: 'Ähnliche Medikamente',
	},
	messages: {
		addedToCart: 'zum Warenkorb hinzugefügt!',
		orderInfo: 'Alle Medikamente werden von lizenzierten Apotheken geliefert...'
	}
};

export default medicineProductDe;


